"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.heightForBoxCountLayoutByActionWithFaces = exports.widthForBoxCountLayoutByActionWithFaces = exports.heightForBoxCountLayoutByAction = exports.widthForBoxCountLayoutByActionAndLocale = exports.heightForButtonCountLayoutByActionWithFaces = exports.widthForButtonCountLayoutByActionWithFaces = exports.heightForButtonCountLayoutByAction = exports.widthForButtonCountLayoutByActionAndLocale = exports.heightForStandardLayoutByActionWithFaces = exports.widthForStandardLayoutByActionWithFaces = exports.heightForStandardLayoutByAction = exports.widthForStandardLayoutByAction = exports.languageToFacebookLocale = exports.ACTION_RECOMMEND = exports.ACTION_LIKE = exports.LAYOUT_BOX_COUNT = exports.LAYOUT_BUTTON_COUNT = exports.LAYOUT_STANDARD = exports.DEFAULT_FACEBOOK_LOCALE = void 0;
exports.DEFAULT_FACEBOOK_LOCALE = 'en_US';
exports.LAYOUT_STANDARD = 'standard';
exports.LAYOUT_BUTTON_COUNT = 'button_count';
exports.LAYOUT_BOX_COUNT = 'box_count';
exports.ACTION_LIKE = 'like';
exports.ACTION_RECOMMEND = 'recommend';
exports.languageToFacebookLocale = {
    da: 'da_DK',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_ES',
    fr: 'fr_FR',
    it: 'it_IT',
    ja: 'ja_JP',
    kr: 'ko_KR',
    nl: 'nl_NL',
    no: 'nn_NO',
    pl: 'pl_PL',
    pt: 'pt_BR',
    ru: 'ru_RU',
    sv: 'sv_SE',
    tr: 'tr_TR',
};
// standard layout
exports.widthForStandardLayoutByAction = (_a = {},
    _a[exports.ACTION_LIKE] = 250,
    _a[exports.ACTION_RECOMMEND] = 290,
    _a);
exports.heightForStandardLayoutByAction = (_b = {},
    _b[exports.ACTION_LIKE] = 40,
    _b[exports.ACTION_RECOMMEND] = 40,
    _b);
exports.widthForStandardLayoutByActionWithFaces = (_c = {},
    _c[exports.ACTION_LIKE] = 250,
    _c[exports.ACTION_RECOMMEND] = 290,
    _c);
exports.heightForStandardLayoutByActionWithFaces = (_d = {},
    _d[exports.ACTION_LIKE] = 85,
    _d[exports.ACTION_RECOMMEND] = 85,
    _d);
// button_count layout
exports.widthForButtonCountLayoutByActionAndLocale = (_e = {},
    _e[exports.ACTION_LIKE] = {
        en_US: 77,
        es_ES: 105,
        ru_RU: 125,
        pt_BR: 95,
        ko_KR: 98,
        de_DE: 114,
        da_DK: 159,
        fr_FR: 92,
        it_IT: 114,
        ja_JP: 104,
        nl_NL: 150,
        nn_NO: 123,
        pl_PL: 114,
        sv_SE: 75,
        tr_TR: 100,
    },
    _e[exports.ACTION_RECOMMEND] = {
        en_US: 121,
        es_ES: 124,
        ru_RU: 153,
        pt_BR: 132,
        ko_KR: 89,
        de_DE: 116,
        da_DK: 121,
        fr_FR: 135,
        it_IT: 121,
        ja_JP: 104,
        nl_NL: 151,
        nn_NO: 101,
        pl_PL: 97,
        sv_SE: 133,
        tr_TR: 120,
    },
    _e);
exports.heightForButtonCountLayoutByAction = (_f = {},
    _f[exports.ACTION_LIKE] = 20,
    _f[exports.ACTION_RECOMMEND] = 20,
    _f);
exports.widthForButtonCountLayoutByActionWithFaces = (_g = {},
    _g[exports.ACTION_LIKE] = 137,
    _g[exports.ACTION_RECOMMEND] = 137,
    _g);
exports.heightForButtonCountLayoutByActionWithFaces = (_h = {},
    _h[exports.ACTION_LIKE] = 20,
    _h[exports.ACTION_RECOMMEND] = 20,
    _h);
// box_count layout
exports.widthForBoxCountLayoutByActionAndLocale = (_j = {},
    _j[exports.ACTION_LIKE] = {
        en_US: 51,
        es_ES: 76,
        ru_RU: 81,
        pt_BR: 58,
        ko_KR: 57,
        de_DE: 83,
        da_DK: 107,
        fr_FR: 63,
        it_IT: 72,
        ja_JP: 72,
        nl_NL: 89,
        nn_NO: 74,
        pl_PL: 75,
        sv_SE: 52,
        tr_TR: 62,
    },
    _j[exports.ACTION_RECOMMEND] = {
        en_US: 95,
        es_ES: 95,
        ru_RU: 109,
        pt_BR: 95,
        ko_KR: 48,
        de_DE: 85,
        da_DK: 69,
        fr_FR: 105,
        it_IT: 78,
        ja_JP: 72,
        nl_NL: 90,
        nn_NO: 52,
        pl_PL: 58,
        sv_SE: 111,
        tr_TR: 82,
    },
    _j);
exports.heightForBoxCountLayoutByAction = (_k = {},
    _k[exports.ACTION_LIKE] = 40,
    _k[exports.ACTION_RECOMMEND] = 40,
    _k);
exports.widthForBoxCountLayoutByActionWithFaces = (_l = {},
    _l[exports.ACTION_LIKE] = 85,
    _l[exports.ACTION_RECOMMEND] = 125,
    _l);
exports.heightForBoxCountLayoutByActionWithFaces = (_m = {},
    _m[exports.ACTION_LIKE] = 65,
    _m[exports.ACTION_RECOMMEND] = 65,
    _m);
//# sourceMappingURL=constants.js.map